import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetPersonalizedDemo as GetPersonalizedDemoQuery,
    GetPersonalizedDemo_personalizedDemo as PersonalizedDemo,
} from 'nutshell-graphql-types';

import GET_PERSONALIZED_DEMO from '../queries/get-personalized-demo.graphql';

export const useGetPersonalizedDemo = (): {
    personalizedDemo: PersonalizedDemo | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetPersonalizedDemoQuery, Record<any, any>>(
        GET_PERSONALIZED_DEMO
    );

    return {
        personalizedDemo: data && data.personalizedDemo,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
